
import React from "react";
import {
    Accordion,
    Button,
    Group,
    Stack,
    Text,
    ThemeIcon,
} from "@mantine/core";
import {
    IconCalendarEvent,
    IconArrowUpRight,
} from "@tabler/icons-react";

type Props = {
    show: boolean;
    eventId: number;
    personId: number;
    language: "da" | "en";
};

export default function TrainingSection({
    show,
    eventId,
    personId,
    language,
}: Props) {
    if (!show) return null;

    const isDanish = language === "da";

    const bookingUrl =
        `/TeamDashboard/Practice/${eventId}/${personId}`;

    return (
        <Accordion.Item value="training">
            <Accordion.Control
                icon={
                    <ThemeIcon
                        color="red"
                        variant="light"
                        radius="xl"
                    >
                        <IconCalendarEvent size={18} />
                    </ThemeIcon>
                }
            >
                {isDanish ? "Tr�ning" : "Training"}
            </Accordion.Control>

            <Accordion.Panel>
                <Stack gap="sm">
                    <Text c="dimmed" size="sm">
                        {isDanish
                            ? "Book tr�ningstider og se tilg�ngelige tr�ningsbaner."
                            : "Book practice sessions and view available training courts."}
                    </Text>

                    <Group justify="flex-end">
                        <Button
                            color="red"
                            variant="light"
                            rightSection={
                                <IconArrowUpRight size={16} />
                            }
                            component="a"
                            href={bookingUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {isDanish
                                ? "Book tr�ning"
                                : "Book Practice"}
                        </Button>
                    </Group>
                </Stack>
            </Accordion.Panel>
        </Accordion.Item>
    );
}
